<template>
  <div v-if="show" class="modal-wrapper">
    <div class="modal-overlay" @click="closeModal"></div>
    <div class="meet-now-modal" :class="{'library-mode': showLibrary}">
      <div @click="closeModal" class="meet-now-modal-close close"></div>
      <div class="meet-now-modal-content">
      <template v-if="isLoading">
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('verifying_age') || 'Verifying Age' }}</span>
        </div>
        <div class="meet-now-modal-content-text text-center">
          <img src="/assets/img/preloader.svg" alt="Loading" class="verification-loader" />
        </div>
      </template>
      <template v-else-if="successVerification">
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('verification_success_title') || 'Verification Complete' }}</span>
        </div>
        <div class="meet-now-modal-content-text">
          {{ trans('verification_success_desc') || 'Your age has been successfully verified.' }}
        </div>
        <div class="meet-now-modal-content-footer">
          <button @click="closeModal" class="btn btn-100 btn-success btn-verify-age">{{ trans('okay') || 'Okay' }}</button>
        </div>
      </template>
      <template v-else-if="limitReached">
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('verification_limit_title') || 'Limit Reached' }}</span>
        </div>
        <div class="meet-now-modal-content-text">
          {{ trans('verification_limit_desc') || 'You have exceeded the maximum number of age verification attempts. Please try again later.' }}
          <br><br>
          {{ trans('try_again_in') || 'Try again in' }} {{ formatRetryTime() }}
        </div>
        <div class="meet-now-modal-content-footer">
          <button @click="closeModal" class="btn btn-100 btn-success btn-verify-age">{{ trans('close') || 'Close' }}</button>
        </div>
      </template>
      <template v-else-if="failedVerification">
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('verification_failed_title') || 'Verification Failed' }}</span>
        </div>
        <div class="meet-now-modal-content-text">
          {{ trans('verification_failed_desc') || 'Verification was not passed. You can try again by selecting or uploading a different photo.' }}
        </div>
        <div class="meet-now-modal-content-footer">
          <button @click="tryAgain" class="btn btn-100 btn-success btn-verify-age">{{ trans('try_again') || 'Try Again' }}</button>
        </div>
      </template>
      <template v-else-if="!showLibrary">
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('verify_age') }}</span>
        </div>
        <div class="meet-now-modal-content-text">
          {{ trans('age_verification_description') }}
        </div>
        <div class="meet-now-modal-content-footer">
          <button @click="startWorkflow" class="btn btn-100 btn-success btn-verify-age">{{ trans('verify_now') }}</button>
        </div>
      </template>
      <template v-else>
        <!-- Photo selection hidden as requested -->
        <!--
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('choose_photo') }}</span>
        </div>
        ...
        -->
        <div class="meet-now-modal-content-headline">
          <span>{{ trans('verify_age') }}</span>
        </div>
        <div class="meet-now-modal-content-text">
          {{ trans('age_verification_description') }}
        </div>
        <div class="meet-now-modal-content-footer">
          <button @click="startWorkflow" class="btn btn-100 btn-success btn-verify-age">{{ trans('verify_now') }}</button>
        </div>
      </template>
    </div>
  </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';

export default {
  mixins: [require('@general/lib/mixin').default],
  data() {
    return {
      showLibrary: false,
      failedVerification: false,
      isLoading: false,
      successVerification: false,
      limitReached: false,
      retryAfterSeconds: 0,
    }
  },
  methods: {
    formatRetryTime() {
      if (!this.retryAfterSeconds) return '';
      const m = Math.floor(this.retryAfterSeconds / 60);
      const s = this.retryAfterSeconds % 60;
      if (m > 0) {
        return `${m}m ${s}s`;
      }
      return `${s}s`;
    },
    closeModal(){
      this.showLibrary = false;
      this.failedVerification = false;
      this.isLoading = false;
      this.successVerification = false;
      this.limitReached = false;
      this.retryAfterSeconds = 0;
      this.closeVerifyAgeModal();
    },
    startVerification(){
      this.showLibrary = true;
      this.successVerification = false;
      this.failedVerification = false;
      this.limitReached = false;
    },
    startWorkflow() {
      this.isLoading = true;
      axios.post('/api/age-verification/create-session')
      .then((apiResponse) => {
        if (apiResponse.data.success && apiResponse.data.verification_url) {
          window.location.href = apiResponse.data.verification_url;
        } else {
          this.isLoading = false;
          this.failedVerification = true;
        }
      })
      .catch((apiError) => {
        this.isLoading = false;
        const errorData = apiError && apiError.data;
        if (apiError && apiError.status === 429) {
          this.limitReached = true;
          this.retryAfterSeconds = (errorData && errorData.retry_after) || 0;
        } else {
          this.failedVerification = true;
        }
      });
    },
    tryAgain() {
      this.failedVerification = false;
      this.showLibrary = true;
    },
    choosePhoto() {
      this.$refs.photo.click();
    },
    selectPhoto(photo) {
      console.log('Selected photo for verification:', photo.id);
      
      this.showLibrary = false;
      this.isLoading = true;
      this.failedVerification = false;
      this.limitReached = false;
      this.retryAfterSeconds = 0;

      axios.post('/api/age-verification/estimate', {
        photo_id: photo.id
      })
      .then((apiResponse) => {
        console.log('DiDiT Response:', apiResponse.data);
        this.isLoading = false;

        if (apiResponse.data.is_adult) {
          this.$store.commit('updateUser', { age_verified_at: new Date().toISOString() });
          this.successVerification = true;
        } else {
          this.failedVerification = true;
        }
      })
      .catch((apiError) => {
        this.isLoading = false;
        
        const errorData = apiError && apiError.data;
        const isRateLimit = apiError && apiError.status === 429;
        const isTooManyAttempts = errorData && errorData.message === 'Too many attempts';
        if (isRateLimit || isTooManyAttempts) {
          this.limitReached = true;
          this.retryAfterSeconds = (errorData && errorData.retry_after) || 0;
        } else {
          this.failedVerification = true;
        }
        console.error('DiDiT API Error:', apiError.response ? apiError.data : apiError);
      });
    },
    async onPhotoUploaded(event) {
        const file = event.target.files[0];
        if (file) {
            // After upload, we might want to trigger verification too.
            // But usually uploadProfilePhoto handles its own flow.
            // Let's just do what's requested for now.
            this.uploadProfilePhoto(event, true);
        }
    }
  },
  computed: {
    ...mapState({
      show: state => state.modal.verify_age,
    }),
    ...mapGetters([
        'photos',
    ]),
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.showLibrary = false;
      }
    }
  }
}
</script>
